import AdressesList from './AdressesList';

import AdresseEditeur from './AdresseEditeur';
import AdresseListItem from './AdresseListItem';
import AdresseSpan from './AdresseSpan';
export default {
  install(Vue) {
    Vue.component('adressesList', AdressesList);
    Vue.component('adresseEditeur', AdresseEditeur);
    Vue.component('adresseListItem', AdresseListItem);
    Vue.component('adresseSpan', AdresseSpan);
  },
};
